"use-strict";

var REGEX_URL =
  /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,12}\b([-a-zA-Z0-ž-9@:%_\+.~#?&\/=]*[-a-zA-Z0-ž-9@:%_\+~!#?&\/=])*/i;
module.exports.REGEX_URL = REGEX_URL;

var REGEX_PHONE = /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,7}/;
module.exports.REGEX_PHONE = REGEX_PHONE;

var REGEX_EMAIL = /\S+@\S+\.\S+/;
module.exports.REGEX_EMAIL = REGEX_EMAIL;

var REGEX_HASHTAG = /(?:^|\s|[^\s\w/-])#([a-zA-Z0-9À-ž_]+)(?![\w-])/;
module.exports.REGEX_HASHTAG = REGEX_HASHTAG;

var REGEX_MENTION = /\B@\w*[a-zA-Z0-9À-ž.]+[a-zA-Z0-9À-ž]\w*/;
module.exports.REGEX_MENTION = REGEX_MENTION;

var REGEX_NETWORK_MENTION = /(@\[[^@]+\]\([a-z]+\:[^)]+\))/;
module.exports.REGEX_NETWORK_MENTION = REGEX_NETWORK_MENTION;

var REGEX_SHORT_URL =
  /(bit\.ly\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+|goo\.gl\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+|lnked\.in\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+|fb\.me\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+|m\.me\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+|t\.co\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+|youtu\.be\/[-a-zA-Z0-ž-9@:%_\+.~#?&\/=]+)/i;
module.exports.REGEX_SHORT_URL = REGEX_SHORT_URL;

var REGEX_EMOJI_HASHTAG =
  /#([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g;
module.exports.REGEX_EMOJI_HASHTAG = REGEX_EMOJI_HASHTAG;

var REGEX_NUMBER = /\d+/g;
module.exports.REGEX_NUMBER = REGEX_NUMBER;

var REGEX_MULTI_LINE_BREAKS = /(\n{2,}|(\r\n){2,})(\n|(\r\n))*?/g;
module.exports.REGEX_MULTI_LINE_BREAKS = REGEX_MULTI_LINE_BREAKS;

var REGEX_COMMENT_USER_MENTION = /(@\[\d+\])/g;
module.exports.REGEX_COMMENT_USER_MENTION = REGEX_COMMENT_USER_MENTION;

var REGEX = {
  URL: REGEX_URL,
  PHONE: REGEX_PHONE,
  EMAIL: REGEX_EMAIL,
  HASHTAG: REGEX_HASHTAG,
  MENTION: REGEX_MENTION,
  NETWORK_MENTION: REGEX_NETWORK_MENTION,
  SHORT_URL: REGEX_SHORT_URL,
  EMOJI_HASHTAG: REGEX_EMOJI_HASHTAG,
  NUMBER: REGEX_NUMBER,
  MULTI_LINE_BREAKS: REGEX_MULTI_LINE_BREAKS,
  COMMENT_USER_MENTION: REGEX_COMMENT_USER_MENTION,
};
module.exports.REGEX = REGEX;
